import { cn } from "src/lib/utils"

const PendingCircle = ({ className }: { className?: string }) => {
  return (
    <svg
      className={cn("h-4 w-4 animate-spin fill-action-primary", className)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Loading</title>
      <path
        d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10H20C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0V2Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default PendingCircle
